import React, { useEffect, useState } from "react";
import { client, urlFor } from "../sanityClient";
import { Link, useLocation } from "react-router-dom";
import { FaFilter } from "react-icons/fa";
import {ChevronLeftIcon, ChevronRightIcon} from "@heroicons/react/16/solid";


const ProductList = () => {
    const location = useLocation();
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [filterOpen, setFilterOpen] = useState(false); // Mobile filter toggle
    const [expandedCategories, setExpandedCategories] = useState([]);

    const toggleExpand = (categoryId) => {
        setExpandedCategories((prev) =>
            prev.includes(categoryId)
                ? prev.filter((id) => id !== categoryId)
                : [...prev, categoryId]
        );
    };

    // Lọc sản phẩm theo danh mục đã chọn
    const filteredProducts = selectedCategories.length
        ? products.filter((product) =>
            selectedCategories.every((categoryId) =>
                product.categories?.some((cat) => cat._id === categoryId)
            )
        )
        : products;

    // Xử lý tick chọn danh mục
    const toggleCategory = (categoryId) => {
        setSelectedCategories((prev) =>
            prev.includes(categoryId)
                ? prev.filter((id) => id !== categoryId)
                : [...prev, categoryId]
        );
    };

    // Lấy category từ URL khi người dùng click vào danh mục
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const categoryFromUrl = params.get("category");
        if (categoryFromUrl) {
            setSelectedCategories([categoryFromUrl]); // Cập nhật danh mục đã chọn
        }
    }, [location]);
    useEffect(() => {

        // Lấy danh sách sản phẩm
        client
            .fetch(
                `*[_type == "product"]{
            _id, name, slug, mainImage, excerpt,
            categories[]->{_id, title, parentCategory->{_id, title, parentCategory->{_id, title}}}
        }`
            )
            .then(setProducts)
            .catch(console.error);

        // Lấy danh sách danh mục (bao gồm cha, con, cháu)
        client
            .fetch(
                `*[_type == "productCategory"]{
            _id, title, parentCategory->{_id}
        }`
            )
            .then((data) => {
                // Tạo cây danh mục cha/con/cháu
                const categoryMap = {};
                data.forEach((cat) => {
                    categoryMap[cat._id] = { ...cat, children: [] };
                });

                data.forEach((cat) => {
                    if (cat.parentCategory?._id) {
                        categoryMap[cat.parentCategory._id]?.children.push(categoryMap[cat._id]);
                    }
                });

                setCategories(Object.values(categoryMap).filter((cat) => !cat.parentCategory));
            })
            .catch(console.error);
    }, []);

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 9; // Số sản phẩm mỗi trang
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentProducts = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };


    const [wishlistPopup, setWishlistPopup] = useState(null); // Lưu sản phẩm popup

    const addToWishlist = (product) => {
        let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

        let message = "";
        if (wishlist.some((item) => item._id === product._id)) {
            message = "Sản phẩm đã có trong danh sách yêu thích.";
        } else {
            wishlist.push(product);
            localStorage.setItem("wishlist", JSON.stringify(wishlist));
            message = "Đã thêm vào danh sách yêu thích.";
        }

        // Hiển thị popup với thông tin sản phẩm
        setWishlistPopup({ product, message });
    };

// Đóng popup
    const closePopup = () => {
        setWishlistPopup(null);
    };




    return (
        <main className="container mx-auto py-12 px-4 lg:px-8 font-Inter pt-[72px] lg:pt-[109px]">
            <div className="container mx-auto py-12 lg:py-24">
                {/* Tiêu đề */}
                <div className="w-full flex flex-col justify-center items-center gap-3 mb-12">
                    <h1 className="text-indigo-800 text-3xl sm:text-4xl font-semibold leading-normal">
                        Sản phẩm của Timo
                    </h1>

                </div>
                <div
                    className="relative w-full py-6 bg-gradient-to-r from-[#33367b] to-[#1e2358] text-white text-center font-semibold text-lg md:text-xl tracking-wide shadow-md mb-6 border-2 border-transparent before:absolute before:inset-0 before:border-[3px] before:border-white before:opacity-10 before:animate-pulse">
                    Sự hoàn hảo được định hình từ chất liệu – Khám phá bộ sưu tập độc quyền tại Timo
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 ">
                    {/* Sidebar danh mục trên Desktop */}
                    <aside className="hidden lg:block px-8 py-1 ">
                        <h3 className="text-[1.25rem] font-medium text-white mb-4 bg-[#33367b] px-3 py-1.5 rounded-md">Lọc sản phẩm</h3>
                        <ul className="space-y-3">
                        {categories.map((category) => (
                            <li key={category._id}>
                                <label
                                    className={`flex items-center space-x-3 px-3 py-2 transition-all duration-300 cursor-pointer border-b border-gray-300 mx-1 ${
                                        selectedCategories.includes(category._id) ? "bg-gray-300 text-gray-800" : "hover:bg-gray-300 text-gray-700"
                                    }`}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedCategories.includes(category._id)}
                                        onChange={() => toggleCategory(category._id)}
                                        className="appearance-none w-0 h-0 border-2 border-gray-800 checked:bg-gray-800 checked:border-transparent transition-all duration-300"
                                    />
                                    <span className=" font-medium text-lg">{category.title}</span>
                                </label>

                                {category.children.length > 0 && (
                                    <ul className="ml-4 mt-2 space-y-2 border-l-2 border-[#33367b] pl-3">
                                        {category.children.map((sub) => (
                                            <li key={sub._id}>
                                                <label
                                                    className={`flex items-center space-x-3 px-3 py-2 rounded-lg transition-all duration-300 cursor-pointer ${
                                                        selectedCategories.includes(sub._id) ? "bg-gray-300 text-gray-700" : "hover:bg-gray-300 text-gray-600"
                                                    }`}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedCategories.includes(sub._id)}
                                                        onChange={() => toggleCategory(sub._id)}
                                                        className="appearance-none w-4 h-4 border-2 border-gray-600 checked:bg-gray-600 checked:border-transparent transition-all duration-300"
                                                    />
                                                    <span
                                                        className=" font-medium text-[1rem]">{sub.title}</span>
                                                </label>

                                                {sub.children.length > 0 && (
                                                    <ul className="ml-4 mt-2 space-y-2 border-l-2 border-[#33367b] pl-3">
                                                        {sub.children.map((child) => (
                                                            <li key={child._id}>
                                                                <label
                                                                    className={`flex items-center space-x-3 px-3 py-2 rounded-lg transition-all duration-300 cursor-pointer ${
                                                                        selectedCategories.includes(child._id) ? "bg-gray-300 text-gray-700" : "hover:bg-gray-300 text-gray-600"
                                                                    }`}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedCategories.includes(child._id)}
                                                                        onChange={() => toggleCategory(child._id)}
                                                                        className="appearance-none w-0 h-0 border-2 border-gray-600 checked:bg-gray-600 checked:border-transparent transition-all duration-300"
                                                                    />
                                                                    <span
                                                                        className="font-OpenSans font-medium text-[0.97rem]">{child.title}</span>
                                                                </label>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>

                        ))}
                        </ul>
                    </aside>


                    {/* Nút lọc trên mobile */}
                    <div className="lg:hidden flex justify-end mb-4">
                        <button
                            onClick={() => setFilterOpen(!filterOpen)}
                            className="flex items-center bg-[#33367b] font-OpenSans font-medium text-white px-4 py-2 shadow-md"
                        >
                            <FaFilter className="mr-2"/>
                            Lọc sản phẩm
                        </button>
                    </div>

                    {/* Hiển thị danh sách sản phẩm */}
                    <section className="lg:col-span-3 grid grid-cols-2 md:grid-cols-3 gap-6">
                        {currentProducts.length > 0 ? (
                            currentProducts.map((product) => (
                                <div className="block shadow-md pt-2 bg-gray-50 border-t border-x-2 border-gray-200 rounded-md overflow-hidden transition-transform">
                                    <Link
                                        key={product._id}
                                        to={`/product/${product.slug.current}`}
                                        className=""
                                    >
                                        <img
                                            src={urlFor(product.mainImage).url()}
                                            alt={product.name}
                                            className="w-[95%] aspect-[7/6] mx-auto object-cover rounded-md"
                                        />
                                        <div className="p-2 flex flex-col flex-grow">
                                            <h2 className="text-xl font-medium">{product.name}</h2>
                                            <p className="text-base font-OpenSans font-normal tracking-tight leading-normal text-gray-600
                                 line-clamp-2 min-h-[48px]">{product.excerpt}</p>
                                        </div>
                                    </Link>
                                    <div className="flex justify-between mt-4">
                                        <Link
                                            to={`/product/${product.slug.current}`}
                                            className="mx-2 mb-2 py-2 px-4 bg-[#D4AF37] text-white font-OpenSans font-medium hover:bg-blue-600 transition duration-200"
                                        >
                                            Chi tiết
                                        </Link>
                                        <button
                                            onClick={() => addToWishlist(product)}
                                            className="pb-2 px-4 transition duration-200 text-[#1a1a1a] hover:text-[#000] grayscale"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                width="24"
                                                height="24"
                                                fill="currentColor"
                                                className="w-6 h-6"
                                            >
                                                <path
                                                    d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            ))
                        ) : (

                            <p className="text-gray-600 col-span-full text-center">
                                Không tìm thấy sản phẩm nào phù hợp.
                            </p>
                        )}
                    </section>
                </div>
                {/* Popup Thông báo Wishlist */}
                {wishlistPopup && (
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
                        onClick={closePopup} // Click ra ngoài để đóng
                    >
                        <div
                            className="bg-white rounded-lg shadow-lg p-6 w-80 sm:w-96"
                            onClick={(e) => e.stopPropagation()} // Ngăn chặn đóng khi click vào popup
                        >
                            <h3 className="text-lg font-semibold text-gray-900 text-center">{wishlistPopup.message}</h3>
                            <div className="flex flex-col items-center mt-4">
                                <img
                                    src={urlFor(wishlistPopup.product.mainImage).url()}
                                    alt={wishlistPopup.product.name}
                                    className="w-32 h-32 object-cover rounded-lg"
                                />
                                <p className="text-gray-800 font-medium mt-2">{wishlistPopup.product.name}</p>
                            </div>

                            {/* Nút điều hướng */}
                            <div className="mt-4 flex justify-between">
                                <button
                                    onClick={closePopup}
                                    className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
                                >
                                    Đóng
                                </button>
                                <Link
                                    to="/wishlist"
                                    className="px-4 py-2 bg-[#33367b] text-white rounded hover:bg-blue-600 transition"
                                >
                                    Xem danh sách
                                </Link>
                            </div>
                        </div>
                    </div>
                )}

                <div className="flex justify-center mt-12 space-x-4">
                    <button
                        onClick={handlePrevPage}
                        disabled={currentPage === 1}
                        className={`px-1.5 py-1.5 bg-[#33367b] rounded-md ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-400"}`}>
                        <ChevronLeftIcon className="h-5 w-5 text-white"/>
                    </button>

                    <span className="text-gray-800 font-semibold text-lg font-OpenSans ">
        {currentPage}
    </span>

                    <button
                        onClick={handleNextPage}
                        disabled={currentPage === totalPages}
                        className={`px-1.5 py-1.5 bg-[#33367b] rounded-md ${currentPage === totalPages ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-400"}`}>
                        <ChevronRightIcon className="h-5 w-5 text-white"/>
                    </button>
                </div>
                {/* Popup bộ lọc trên mobile */}
                {filterOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                        <div className="bg-white p-6 w-11/12 max-w-sm rounded-lg shadow-lg overflow-y-auto max-h-[80vh]">
                            {/* Tiêu đề */}
                            <h3 className="text-2xl font-semibold text-[#33367b] mb-4 text-center border-b pb-2">Lọc sản phẩm</h3>

                            {/* Danh mục */}
                            <ul className="space-y-3 font-OpenSans">
                                {categories.map((category) => (
                                    <li key={category._id} className="">
                                        <div
                                            className="flex justify-between items-center cursor-pointer py-2 px-3 bg-[#f8f8f8] rounded-lg hover:bg-[#eaeaea] transition-all duration-300"
                                            onClick={() => toggleExpand(category._id)}
                                        >
                                            <label className="flex items-center space-x-3 font-semibold text-lg text-[#33367b] ">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedCategories.includes(category._id)}
                                                    onChange={() => toggleCategory(category._id)}
                                                    className="w-0 h-0 appearance-none border-2 border-[#33367b] mr-2 checked:bg-[#33367b] checked:border-transparent transition-all duration-300"
                                                />
                                                {category.title}
                                            </label>
                                            {category.children.length > 0 && (
                                                <span className="text-[#33367b] text-xl">
                                    {expandedCategories.includes(category._id) ? '−' : '+'}
                                </span>
                                            )}
                                        </div>

                                        {/* Danh mục con */}
                                        {expandedCategories.includes(category._id) && category.children.length > 0 && (
                                            <ul className="ml-4 mt-2 space-y-2 border-l-2 border-[#D4AF37] pl-3">
                                                {category.children.map((sub) => (
                                                    <li key={sub._id}>
                                                        <div
                                                            className="flex justify-between items-center cursor-pointer py-2 px-3 bg-[#f4f4f4] rounded-lg hover:bg-[#e1e1e1] transition-all duration-300"
                                                            onClick={() => toggleExpand(sub._id)}
                                                        >
                                                            <label className="flex items-center space-x-3 font-medium text-[1rem] text-[#5056a1]">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedCategories.includes(sub._id)}
                                                                    onChange={() => toggleCategory(sub._id)}
                                                                    className="w-4 h-4 appearance-none border-2 border-[#5056a1] mr-2 checked:bg-[#5056a1] checked:border-transparent transition-all duration-300"
                                                                />
                                                                {sub.title}
                                                            </label>
                                                            {sub.children.length > 0 && (
                                                                <span className="text-[#5056a1] text-lg">
                                                    {expandedCategories.includes(sub._id) ? '−' : '+'}
                                                </span>
                                                            )}
                                                        </div>

                                                        {/* Danh mục cháu */}
                                                        {expandedCategories.includes(sub._id) && sub.children.length > 0 && (
                                                            <ul className="ml-4 mt-2 space-y-2 border-l-2 border-[#D4AF37] pl-3">
                                                                {sub.children.map((child) => (
                                                                    <li key={child._id}>
                                                                        <label className="flex items-center space-x-3 font-medium text-[0.97rem] text-[#8c92e3]">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={selectedCategories.includes(child._id)}
                                                                                onChange={() => toggleCategory(child._id)}
                                                                                className="w-0 h-0 appearance-none border-2 border-[#8c92e3] mr-2 checked:bg-[#8c92e3] checked:border-transparent transition-all duration-300"
                                                                            />
                                                                            {child.title}
                                                                        </label>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </li>
                                ))}
                            </ul>

                            {/* Nút đóng */}
                            <button
                                onClick={() => setFilterOpen(false)}
                                className="mt-6 font-OpenSans w-full bg-[#33367b] text-white py-3 font-medium text-lg shadow-md hover:bg-[#5056a1] transition-all duration-300"
                            >
                                Đóng
                            </button>
                        </div>
                    </div>
                )}

            </div>

        </main>
    );
};

export default ProductList;
